<template>
  <r-panel :disabled="disabled" :title="title">
    <v-divider/>
    <v-card width="100%" class="ma-0 pa-2 mt-2" elevation="0" outlined>
      <v-card-title class="blue--text pa-0 ma-0 ml-1 mb-2">Common</v-card-title>
      <v-row dense>
        <v-col cols="12" md="4" sm="4">
          <r-currency-kind-dropdown :model.sync="value.currencyGear" label="Currency Gear"/>
        </v-col>
        <v-col cols="12" sm="4" md="4">
          <v-text-field v-model.trim="value.multipliersString" label="Multiplier" :rules="[validator.points]" hint="Example: 1;3;5"/>
        </v-col>
      </v-row>
    </v-card>
    <r-plinko-ball-config :model.sync="value.ball"/>
    <r-plinko-spring-config :model.sync="value.spring"/>
    <v-card width="100%" class="ma-0 pa-2 mt-3" elevation="0" outlined>
      <v-card-title class="blue--text pa-0 ma-0 ml-1 mb-2">Stages</v-card-title>
      <v-row dense class="pt-4">
        <r-plinko-stage-config-table ref="table" :items.sync="value.stages" title="Stages"/>
      </v-row>
    </v-card>
  </r-panel>
</template>
<script>

import VueTypes from "vue-types";
import {PlinkoGameConfig} from "@/modules/redactor/models/smart-offer/bundle-plinko/PlinkoGameConfig";

import RPanel from "@/modules/redactor/views/utils/r-panel.vue";
import RCurrencyKindDropdown from "@/modules/redactor/views/currency-kind/r-currency-kind-dropdown.vue";
import RPlinkoStageConfigTable from "@/modules/redactor/views/smart-offer/bundle-plinko/r-plinko-stage-config-table.vue";
import RPlinkoSpringConfig from "@/modules/redactor/views/smart-offer/bundle-plinko/r-plinko-spring-config.vue";
import RPlinkoBallConfig from "@/modules/redactor/views/smart-offer/bundle-plinko/r-plinko-ball-config.vue";


export default {
  name: "r-plinko-game-config-panel",
  components: {
    RPlinkoBallConfig,
    RPlinkoSpringConfig,
    RPlinkoStageConfigTable,
    RCurrencyKindDropdown,
    RPanel
  },
  props: {
    disabled: VueTypes.bool.def(false),
    title: VueTypes.string.def("Plinko Config"),
    model: VueTypes.instanceOf(PlinkoGameConfig),
  },
  data: () => ({
    validator: {
      points: value => value.length === 0 || !value.split(";").map(Number).some(v => !Number.isInteger(v) || v <= 0)
    }
  }),
  computed: {
    value() {
      if (this.model) {
        return this.model;
      } else {
        let value = new PlinkoGameConfig();
        this.$emit("update:model", value);
        return value;
      }
    }
  }
}

</script>